import api from './client';
import type { PermissionScopeResp } from '@/types/permissions';

/**
 * Fetches a list of company permissions
 *
 * @param companyId - The ID of the company
 *
 * @returns A promise that resolves with a list of company permissions
 */
export async function getCompanyPermissions(companyId: string, lang?: string) {
  const { data } = await api.get(getBaseUrl(companyId), { params: { lang } });
  return data;
}

/**
 * Fetches the scope of a company permission
 *
 * @param companyId - The ID of the company
 *
 * @returns A promise that resolves with the scope of the company permission
 */
export async function getPermissionScope(companyId: string) {
  const { data } = await api.get<PermissionScopeResp>(
    `${getBaseUrl(companyId)}/scopes`
  );
  return data;
}

// -----------------------------------------------------------------------------------------------------
// @ local functions
// -----------------------------------------------------------------------------------------------------

/**
 * Returns the base URL for making requests related to company admin permissions
 *
 * @param companyId - The ID of the company
 * @returns The base URL for making requests related to company admin permissions
 */
function getBaseUrl(companyId: string) {
  return <const>`/companies/${companyId}/company-admin-permissions`;
}
